<script>
  import ArrowProfile from '@/assets/arrow-profile.svg';
  import MainDropdown from '@/components/Main/Dropdown';

  export default {
    components: {
      MainDropdown,
      ArrowProfile,
    },

    data: () => ({
      show: false,
    }),

    computed: {
      center () {
        return this.$route.meta.center_nav === true;
      },
    },
  };
</script>

<template>
  <nav
    class="nav"
    :class="{ 'nav--center': center }"
    >

    <RouterLink
      to="/"
      class="nav__logo"
      >
      <img src="@/assets/logo.png" srcset="@/assets/logo@2x.png 2x, @/assets/logo@3x.png 3x">
    </RouterLink>

    <ul class="nav__links" v-if="! center">
      <li class="nav__item">
        <RouterLink
          to="/dashboard"
          class="nav__link"
          active-class="nav__link--active"
          >
          Dashboard
        </RouterLink>
      </li>

      <li class="nav__item">
        <RouterLink
          to="/negociar"
          class="nav__link"
          active-class="nav__link--active"
          >
          Negociar
        </RouterLink>
      </li>

      <li class="nav__item">
        <RouterLink
          to="/financeiro"
          class="nav__link"
          active-class="nav__link--active"
          >
          Financeiro
        </RouterLink>
      </li>

      <li class="nav__item">
        <RouterLink
          to="/carteira"
          class="nav__link"
          active-class="nav__link--active"
          >
          Carteira
        </RouterLink>
      </li>

      <li class="nav__item">
        <RouterLink
          to="/atendimento"
          class="nav__link"
          active-class="nav__link--active"
          >
          Atendimento
        </RouterLink>
      </li>
    </ul>

    <div
      v-if="! center"
      class="nav__user"
      @click="show = ! show"
      >
      <img class="nav__avatar" src="@/assets/icon-profile.jpg" srcset="@/assets/icon-profile@2x.jpg 2x, @/assets/icon-profile@3x.jpg 3x">

      <ArrowProfile
        class="nav__arrow"
        :class="{ 'nav__arrow--active': show }"
        />

      <transition name="fade-up">
        <MainDropdown
          v-if="show"
          @close="show = false"
          />
      </transition>
    </div>
  </nav>
</template>

<style lang="scss">
  .nav {
    display: flex;
    padding: 12px 18px;
    align-items: center;
    background-color: #282a49;
    justify-content: space-between;

    &--center {
      justify-content: center;
    }

    &__logo {
      display: flex;
      padding: 4px 6px;

      img {
        height: 23px;
      }
    }

    &__links {
      color: #fff;
      display: flex;
      font-size: 15px;
      line-height: 1.07;
    }

    &__link {
      opacity: .7;
      height: 28px;
      display: flex;
      padding: 0 10px;
      border-radius: 3px;
      align-items: center;
      letter-spacing: .3px;

      $margin: 12px;

      &:first-child {
        margin-right: $margin;
      }

      &:not(first-child):not(last-child) {
        margin: 0 $margin;
      }

      &:last-child {
        margin-left: $margin;
      }

      &:hover {
        background-color: rgba(#FFF, .1);
      }

      &--active {
        opacity: 1;
        background-color: rgba(#FFF, .15) !important;
      }
    }

    &__avatar {
      width: 29px;
      width: 29px;
      margin-right: 8px;
      border-radius: 9999px;
    }

    &__user {
      width: 122px;
      display: flex;
      cursor: pointer;
      position: relative;
      align-items: center;
      justify-content: flex-end;
    }

    &__arrow {
      transition: 150ms;

      &--active {
        transform: rotate(180deg);
      }
    }
  }
</style>
